module.exports = __webpack_public_path__ + "img/gushi.6fbca272.png";